import ConsultationsUserSubordinationArchive from 'features/consultations/consultationsUserSubordinationArchive';
import { useTitle } from '../helpers';

/**
 * @page Consultation user subordination archive page
 */
const ConsultationUserSubordinationArchivePage = () => {
  useTitle('Информация о консультации в архиве подчинённых');

  return (
    <div>
      <h3>Страница информации о консультации в архиве подчинённых</h3>
      <ConsultationsUserSubordinationArchive />
    </div>
  );
};

export default ConsultationUserSubordinationArchivePage;
